import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchData, updateData } from '../../apiService';
import { useAuth } from '../../AuthContext';
import { tokenIsExpired } from '../../authUtils';
import Button from '@mui/material/Button';
import { Card, CardContent, Modal } from '@mui/material';
import CopyrightIcon from '@mui/icons-material/Copyright';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import IconButton from '@mui/material/IconButton';

function Home() {
   
    const { isAuthenticated, companyId, branchId, UserId, logout, token } = useAuth();
    const { id } = useParams();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, UserId, token, logout, id]);

   
    return (
        <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '730px', overflow: 'auto' }}>

        </div>
    );
}

export default Home;
